import { useEffect, useState } from 'react';
import axios from 'axios';

export const useDebouncedValue = (value, delay = 350) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
};

// GET that cancels the previous request whenever the URL (or refresh key) changes.
export const useAbortableGet = (url, refreshKey = 0) => {
  const [state, setState] = useState({ data: null, loading: true, error: '' });
  useEffect(() => {
    if (!url) return undefined;
    const controller = new AbortController();
    setState(prev => ({ ...prev, loading: true, error: '' }));
    axios.get(url, { signal: controller.signal })
      .then(res => { if (!controller.signal.aborted) setState({ data: res.data, loading: false, error: '' }); })
      .catch(err => {
        if (controller.signal.aborted) return;
        setState(prev => ({ ...prev, loading: false, error: err.response?.data?.detail || 'Could not load data. Please retry.' }));
      });
    return () => controller.abort();
  }, [url, refreshKey]);
  return state;
};

export const queryString = params => new URLSearchParams(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '' && value !== 'ALL')
).toString();
